import React, { useEffect, useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const [time, setTime] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const accordionData = [
    {
      title: 'What is ViralGPT?',
      content:
        'ViralGPT is an AI-powered growth platform that helps you gain targeted growth across multiple social media platforms including Instagram, TikTok, YouTube and X (Twitter).',
    },
    {
      title: 'How does ViralGPT work?',
      content:
        'ViralGPT uses artificial intelligence to analyze your profile and content. Our AI ensures growth by focusing on using the right hashtags, keywords, and targeting the right audience.',
    },
    {
      title: 'Is it safe to use?',
      content:
        'Absolutely! ViralGPT operates within platform guidelines and never requires your password. We use ethical growth methods that protect your account while delivering real results.',
    },
    {
      title: 'What kind of results can I expect?',
      content:
        'Results vary based on your content quality and niche, but our users typically see significant follower growth within the first month.',
    },
	{
		title: 'How do I cancel my subscription?',
		content: 'You can cancel your subscription at any time by going to your account settings and clicking the "Billing" tab.'
	},
	{
		title: 'Do you offer a money back guarantee?',
		content: 'Yes, we offer a 30 day money back guarantee. If you are not happy with the results, we will refund your purchase.'
	}
  ];

  var derp = [];
  var derp = [];
  for (var i = 0; i < 10; i++) {
    derp.push(i);
  }
  derp = <div>{derp}</div>;

  useEffect(
    function () {
      const interval = setInterval(() => {
        setTime(time + 1);
      }, 1000);
      return () => clearInterval(interval);
    },
    [time],
  );

  return (
    <div id="faq" className="mx-auto mb-20 mt-10 max-w-2xl text-center">
		        <span className="text-4xl text-instagram font-bold">Common Questions</span>
      {accordionData.map((item, index) => (
        <div key={index} className="border-b border-gray-200">
          {/* Accordion Header */}
          <button
            onClick={() => toggleAccordion(index)}
            className="flex w-full items-center justify-between p-4 text-left text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <span className="font-medium">{item.title}</span>
            <svg
              className={`h-5 w-5 transition-transform ${
                openIndex === index ? 'rotate-180' : ''
              }`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {/* Accordion Content */}
          {openIndex === index && (
            <div className="p-4 text-gray-600 text-start">{item.content}</div>
          )}
        </div>
      ))}
    
    
    </div>
  );
};

export default FAQ;
